import { useFormContext } from 'react-hook-form'

const SwitchInput = ({ name }) => {
  const { register } = useFormContext()

  return (
    <div className="block h-full" data-gt-name="componentevent">
      <ul className="grid w-full h-full grid-cols-2">
        <li>
          <input
            type="radio"
            id="time-am"
            value="AM"
            className="hidden peer"
            data-gt-action="switch-input-interaction"
            data-gt-label={name}
            {...register(name)}
          />
          <label
            htmlFor="time-am"
            className="flex items-center justify-center w-full h-full border border-secondary cursor-pointer peer-checked:bg-secondary peer-checked:text-white"
          >
            <div className="block">
              <div className="w-full">AM</div>
            </div>
          </label>
        </li>
        <li>
          <input
            type="radio"
            id="time-pm"
            value="PM"
            className="hidden peer"
            data-gt-action="switch-input-interaction"
            data-gt-label={name}
            {...register(name)}
          />
          <label
            htmlFor="time-pm"
            className="flex items-center justify-center w-full h-full border border-secondary cursor-pointer peer-checked:bg-secondary peer-checked:text-white"
          >
            <div className="block">
              <div className="w-full">PM</div>
            </div>
          </label>
        </li>
      </ul>
    </div>
  )
}

export default SwitchInput
